import React, { useState, useContext, useRef} from "react";
import http from "../../../shared/http-common";
import {TokenContext} from "../../Store";

import {trackPromise} from "react-promise-tracker";
import {List, ListItem} from "@mui/material";
import ObjecttypeSelectlist from "../../../shared/ObjecttypeSelectlist";
import MaterialTable from "@material-table/core";
import SaveIcon from "@mui/icons-material/Save";
import ProjectService from "../../../services/ProjectService";

import { header } from'../../../shared/headerStyle';

const options = [
    {value: '', text: '-- Bitte wählen Sie einen Objekttypen --'},
    {value: 'territorialdivision', text: 'Gebietsgliederung'},
    {value: 'site', text: 'Liegenschaft'},
    {value: 'economicunit', text: 'Wirtschaftseinheit'},
    {value: 'structure', text: 'Bauwerk'},
    {value: 'building', text: 'Gebäude'},
    {value: 'storey', text: 'Geschoß'},
    {value: 'buildingentrance', text: 'Hauseingang'},
    {value: 'rentalunit', text: 'Mieteinheit'},
    {value: 'commercialunit', text: 'Gewerbeeinheit'},
    {value: 'apartment', text: 'Wohnung'},
    {value: 'room', text: 'Raum'},
    {value: 'playground', text: 'Spielplatz'},
    {value: 'parkingspace', text: 'Stellplatz'},
];

const OBJECTTYPE_CONFIG = {
    site:                 { objecttype: 'realestateobject',    type: 'site',                title: 'Liegenschaften',       fieldType: 'realestateobjectType' },
    structure:            { objecttype: 'realestateobject',    type: 'structure',           title: 'Bauwerke',             fieldType: 'realestateobjectType' },
    building:             { objecttype: 'realestateobject',    type: 'building',            title: 'Gebäude',              fieldType: 'realestateobjectType' },
    room:                 { objecttype: 'realestateobject',    type: 'room',                title: 'Räume',                fieldType: 'realestateobjectType' },
    storey:               { objecttype: 'realestateobject',    type: 'storey',              title: 'Etagen',               fieldType: 'realestateobjectType' },
    playground:           { objecttype: 'realestateobject',    type: 'playground',          title: 'Spielplätze',          fieldType: 'realestateobjectType' },
    wastecollectionpoint: { objecttype: 'realestateobject',    type: 'wastecollectionpoint', title: 'Müllstandplatz',      fieldType: 'realestateobjectType' },
    economicunit:         { objecttype: 'administrativeobject', type: 'economicunit',       title: 'Wirtschafteinheiten',  fieldType: 'administrativeobjectType' },
    apartment:            { objecttype: 'administrativeobject', type: 'apartment',          title: 'Wohnungen',            fieldType: 'administrativeobjectType' },
    rentalunit:           { objecttype: 'administrativeobject', type: 'rentalunit',         title: 'Mieteinheiten',        fieldType: 'administrativeobjectType' },
    commercialunit:       { objecttype: 'administrativeobject', type: 'commercialunit',     title: 'Gewerbeeinheiten',     fieldType: 'administrativeobjectType' },
    parkingspace:         { objecttype: 'administrativeobject', type: 'parkingspace',       title: 'Stellplatzanlagen',    fieldType: 'administrativeobjectType' },
    location:             { objecttype: 'administrativeobject', type: 'buildingentrance',   title: 'Hauseingänge',         fieldType: 'administrativeobjectType' }, // intentional fallthrough to buildingentrance
    buildingentrance:     { objecttype: 'administrativeobject', type: 'buildingentrance',   title: 'Hauseingänge',         fieldType: 'administrativeobjectType' },
    parcel:               { objecttype: 'administrativeobject', type: 'parcel',             title: 'Flurstücke',           fieldType: 'administrativeobjectType' },
    territorialdivision:  { objecttype: 'administrativeobject', type: 'territorialdivision', title: 'Gebietsgliederungen', fieldType: 'administrativeobjectType' },
    washhouse:            { objecttype: 'administrativeobject', type: 'washhouse',          title: 'Waschhäuser',          fieldType: 'administrativeobjectType' },
};

const DEFAULT_CONFIG = { objecttype: 'administrativeobject', type: 'economicunit', title: 'Wirtschaftseinheiten', fieldType: 'administrativeobjectType' };

const GetObjectDataByType = async (objecttype, type, theRealm, token) => {
    try {
        const formData = new FormData();
        formData.append("realm", theRealm);
        return await http.post(`/${objecttype}/${type}/list`, formData, {
            headers: {
                "Content-Type": "application/json",
                "Authorization": "Bearer " + token
            }
        });
    } catch (e) {
        console.error(e);
        throw e;
    }
};

function ProjectObjectsSelect({projectGuid, realm, projectId}) {
    const [token] = useContext(TokenContext);
    const [isLoading, setIsLoading] = useState(false);
    const [dataObjects, setDataObjects] = useState([]);
    const tableRef = useRef();

    const [selected, setSelected] = useState(options[0].value);
    const [title, setTitle] = useState('Bitte wählen Sie einen Objekttypen');
    const [fieldType, setFieldType] = useState('administrativeobjectType');

    const tableHeight = (window.innerHeight - 74 - 52 - 1) / window.innerHeight * 100;

    const handleObjecttypeChange = async (objecttype, type) => {
        try {
            setIsLoading(true);
            const res = await trackPromise(GetObjectDataByType(objecttype, type, realm, token));
            setDataObjects(res.data);
        } catch (e) {
            console.error('Fehler beim Laden der Objekte:', e);
        } finally {
            setIsLoading(false);
        }
    };

    const handleChange = async (event) => {
        const value = event.target.value;
        setSelected(value);
        const config = OBJECTTYPE_CONFIG[value] || DEFAULT_CONFIG;
        setTitle(config.title);
        setFieldType(config.fieldType);
        await handleObjecttypeChange(config.objecttype, config.type);
    };

    const getObjectType = (obj) =>
        obj.administrativeobjectTypeGuid ? 'administrativeobject' : 'realestateobject';

    const handleAssignClick = async (object, event) => {
        event.preventDefault();
        setIsLoading(true);
        try {
            if (object instanceof Array) {
                await Promise.all(
                    object.map(obj => ProjectService.saveProjectObject(
                        token, realm, projectId, projectGuid, obj.id, obj.guid, getObjectType(obj)
                    ))
                );
            } else {
                await ProjectService.saveProjectObject(
                    token, realm, projectId, projectGuid, object.id, object.guid, getObjectType(object)
                );
            }
        } catch (e) {
            console.error('Fehler beim Zuweisen des Objekts:', e);
        } finally {
            setIsLoading(false);
        }
    };

    return (
        <>
            <List style={{backgroundColor: "#FFFFFF"}}>
                <ListItem>
                    <ObjecttypeSelectlist
                        options={options}
                        selected={selected}
                        handleChange={handleChange}
                    />
                </ListItem>
            </List>
            <MaterialTable
                tableRef={tableRef}
                title={title}
                columns={[
                    { title: 'Bezeichnung', field: 'name' },
                    { title: 'Nummer', field: 'number' },
                    { title: 'Kennzeichen', field: 'label' },
                    { title: 'Typ', field: fieldType },
                ]}
                data={dataObjects}
                options={{
                    headerStyle: header,
                    rowStyle: rowData => ({
                        backgroundColor: rowData.deactivated ? '#EEE' : '#FFF'
                    }),
                    pageSize: 10,
                    pageSizeOptions: [10, 20, 50, 100],
                    actionsColumnIndex: -1,
                    selection: true,
                    exportButton: true,
                    exportAllData: true,
                    maxBodyHeight: `${tableHeight}vh`,
                    minBodyHeight: `${tableHeight}vh`,
                }}
                isLoading={isLoading}
                localization={{
                    pagination: {
                        labelDisplayedRows: '{from}-{to} von {count}',
                        labelRowsSelect: 'Zeilen',
                        labelRowsPerPage: 'Zeilen pro Seite'
                    },
                    toolbar: {
                        nRowsSelected: '{0} Zeile(n) ausgewählt',
                        searchTooltip: 'Suchen',
                        searchPlaceholder: 'Suchbegriff eingeben'
                    },
                    header: {
                        actions: 'zuweisen'
                    },
                    body: {
                        emptyDataSourceMessage: 'Keine Einträge gefunden',
                        filterRow: {
                            filterTooltip: 'Filter'
                        }
                    }
                }}
                onRowClick={(event, rowData) => {
                    const rowDataCopy = { ...rowData };
                    rowDataCopy.tableData.checked = !rowDataCopy.tableData.checked;
                    const dataCopy = [...dataObjects];
                    dataCopy[rowDataCopy.tableData.id] = rowDataCopy;
                    setDataObjects(dataCopy);
                }}
                actions={[
                    rowData => ({
                        icon: () => <SaveIcon />,
                        tooltip: 'dem Projekt zuweisen',
                        onClick: (event, rowData) => handleAssignClick(rowData, event)
                    }),
                ]}
            />
        </>
    );
}

export default ProjectObjectsSelect;
